import React, { useState, useEffect, useRef } from "react";
import Check from "assets/icon/Check.svg";
import { Button } from "@material-ui/core";
import Countdown from "react-countdown";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchBod2Questions,
  postBod2Answer,
  setBod2Question,
} from "redux/actions/assestment";
// import { isMobile } from "react-device-detect";
import "../style.css";
import "../responsive.css";
import Loader from "components/Loading";
import Camera from "components/Camera";
import { modalToggle } from "redux/actions/general";
import Modal from "components/Modal";
import Cookie from "universal-cookie";
import Watermark from "components/Watermark";
import { getDetailUser } from "redux/actions/peserta";

const cookie = new Cookie();

const Navbar = React.memo((props) => {
  const dispatch = useDispatch();
  const TOTAL_TIME = 30 * 60 * 1000;
  const [remainingTime, setRemainingTime] = useState(TOTAL_TIME);
  const sessionStartRef = useRef(null);
  const initialElapsedRef = useRef(0);
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (!hasInitialized.current) {
      const savedElapsed = cookie.get("elapsed_time_bod2");
      const startTime = cookie.get("start_time_bod2");

      if (savedElapsed !== undefined && startTime) {
        const elapsedSinceStart = Date.now() - parseInt(startTime);
        const totalElapsed = Math.max(
          parseInt(savedElapsed),
          elapsedSinceStart,
        );
        initialElapsedRef.current = totalElapsed;
        setRemainingTime(Math.max(0, TOTAL_TIME - totalElapsed));
      }
      sessionStartRef.current = Date.now();
      hasInitialized.current = true;
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      const currentSessionTime = Date.now() - sessionStartRef.current;
      const totalElapsed = initialElapsedRef.current + currentSessionTime;
      const remaining = Math.max(0, TOTAL_TIME - totalElapsed);

      setRemainingTime(remaining);

      cookie.set("elapsed_time_bod2", totalElapsed, { path: "/" });

      if (totalElapsed >= TOTAL_TIME && remaining === 0) {
        clearInterval(interval);
        props.onTimeUp && props.onTimeUp();
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const onClickHelp = () => {
    dispatch(
      modalToggle({
        modal_open: true,
        modal_title: "",
        modal_component: "assessment_instruction",
        modal_size: 700,
        modal_type: "",
        modal_data: { assessmentType: "bod2" },
        modal_action: "success",
      }),
    );
  };

  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      return <span className="timer-expired">00:00:00</span>;
    } else {
      return (
        <span className="timer">
          {hours > 0 ? `${hours < 10 ? "0" : ""}${hours}:` : ""}
          {minutes < 10 ? "0" : ""}
          {minutes}:{seconds < 10 ? "0" : ""}
          {seconds}
        </span>
      );
    }
  };

  let username = props.profile.userName.split(" ")[0];

  return (
    <div className="navbar-wrapper">
      <div className="div-flex div-space-between div-align-center navbar">
        <h3>
          Selamat mengerjakan <br className="show-mobile" />{" "}
          <span className="name">{username}</span>
        </h3>
        <div className="assestmen-toolbar div-flex div-align-center div-space-between">
          <div className="div-flex div-align-center">
            <p
              className="hide-mobile"
              style={{ color: "white", fontWeight: "bold", margin: 0 }}
            >
              Gambaran umum perusahaan dan Petunjuk pengisian
            </p>
            &nbsp;&nbsp;
            <div onClick={onClickHelp} className="circle-help">
              <span>?</span>
            </div>
          </div>
          <div
            className="hide-mobile"
            style={{ width: 1.3, height: 30, backgroundColor: "white" }}
          ></div>
          <h3>
            Sisa waktu <br className="show-mobile" />
            <Countdown date={Date.now() + remainingTime} renderer={renderer} />
          </h3>
        </div>
      </div>
    </div>
  );
});

const MobileStickyNav = ({ questions, currentIndex, onNavigate }) => {
  const scrollContainerRef = useRef(null);

  useEffect(() => {
    if (scrollContainerRef.current) {
      const activeBox = scrollContainerRef.current.querySelector(
        ".mobile-nav-box.active",
      );
      if (activeBox) {
        activeBox.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center",
        });
      }
    }
  }, [currentIndex]);

  const getBoxColor = (question) => {
    const hasBest = question.list_question.some((opt) => opt.answer === "BEST");
    const hasPoor = question.list_question.some((opt) => opt.answer === "POOR");
    if (hasBest && hasPoor) return "answered";
    if (hasBest || hasPoor) return "partial";
    return "";
  };

  const answeredCount = questions.filter((q) => {
    const hasBest = q.list_question.some((opt) => opt.answer === "BEST");
    const hasPoor = q.list_question.some((opt) => opt.answer === "POOR");
    return hasBest && hasPoor;
  }).length;
  const totalCount = questions.length;

  return (
    <div className="mobile-sticky-nav">
      <div className="mobile-nav-progress">
        <span className="mobile-nav-progress-text">
          Sudah dijawab:{" "}
          <strong>
            {answeredCount}/{totalCount}
          </strong>
        </span>
      </div>
      <div className="mobile-nav-scroll" ref={scrollContainerRef}>
        {questions.map((q, idx) => (
          <div
            key={q.questionId}
            onClick={() => onNavigate(idx)}
            className={`mobile-nav-box ${getBoxColor(q)} ${
              currentIndex === idx ? "active" : ""
            }`}
          >
            {q.number}
          </div>
        ))}
      </div>
    </div>
  );
};

const QuestionNavigation = ({ questions, currentIndex, onNavigate }) => {
  const getBoxColor = (question) => {
    const hasBest = question.list_question.some((opt) => opt.answer === "BEST");
    const hasPoor = question.list_question.some((opt) => opt.answer === "POOR");
    if (hasBest && hasPoor) return "#28a745";
    if (hasBest || hasPoor) return "#ffc107";
    return "#e9ecef";
  };

  return (
    <div className="question-nav-sidebar">
      <h4 className="question-nav-title">Soal</h4>
      <div className="question-nav-grid">
        {questions.map((q, idx) => {
          const boxColor = getBoxColor(q);
          return (
            <div
              key={q.questionId}
              onClick={() => onNavigate(idx)}
              className={`question-nav-box ${
                boxColor === "#28a745"
                  ? "answered"
                  : boxColor === "#ffc107"
                    ? "partial"
                    : ""
              } ${currentIndex === idx ? "active" : ""}`}
              style={{
                backgroundColor: boxColor,
                color:
                  boxColor === "#28a745" || boxColor === "#ffc107"
                    ? "white"
                    : "#333",
              }}
            >
              {q.number}
            </div>
          );
        })}
      </div>
      <div className="question-nav-legend">
        <div className="legend-item">
          <div className="legend-box answered"></div>
          <span>Sudah dijawab</span>
        </div>
        <div className="legend-item">
          <div className="legend-box partial"></div>
          <span>Sebagian</span>
        </div>
        <div className="legend-item">
          <div className="legend-box"></div>
          <span>Belum dijawab</span>
        </div>
      </div>
    </div>
  );
};

export default function AssestmentBod2(props) {
  const dispatch = useDispatch();
  const bod2QuestionRef = useRef([]);
  const assestment = useSelector((state) => state.assestment);
  const general = useSelector((state) => state.general);
  const peserta = useSelector((state) => state.peserta);
  const { detail_peserta } = peserta;
  const { bod2Question } = assestment;
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const [expired, setExpired] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!detail_peserta.no_ktp || detail_peserta.no_ktp === "") {
      dispatch(getDetailUser(`/${props.profile.id}`));
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const savedAnswers = localStorage.getItem("bod2_answers");
    const savedIndex = localStorage.getItem("bod2_current_index");

    if (savedAnswers) {
      dispatch(setBod2Question(JSON.parse(savedAnswers)));
      if (savedIndex) {
        setCurrentIndex(parseInt(savedIndex));
      }
    } else {
      dispatch(fetchBod2Questions());
    }
  }, []);

  useEffect(() => {
    if (bod2Question && bod2Question.length > 0) {
      bod2QuestionRef.current = bod2Question;
    }
  }, [bod2Question]);

  useEffect(() => {
    if (props.autoSubmitRef) {
      props.autoSubmitRef.current = handleTimeUp;
    }
  }, []);

  const chooseAnswer = (q1, q2, optionId, answers) => {
    const updatedQuestions = [...bod2Question];
    const currentQuestion = updatedQuestions[q1];

    if (answers === "BEST") {
      currentQuestion.list_question.forEach((opt) => {
        if (opt.answer === "BEST") opt.answer = "";
      });
      currentQuestion.list_question[q2].answer = "BEST";
    } else {
      currentQuestion.list_question.forEach((opt) => {
        if (opt.answer === "POOR") opt.answer = "";
      });
      currentQuestion.list_question[q2].answer = "POOR";
    }

    dispatch(setBod2Question(updatedQuestions));
    localStorage.setItem("bod2_answers", JSON.stringify(updatedQuestions));
    localStorage.setItem("bod2_current_index", currentIndex);
  };

  const handleNavigate = (index) => {
    setCurrentIndex(index);
    localStorage.setItem("bod2_current_index", index);
    window.scrollTo(0, 0);
  };

  const handleNext = () => {
    if (currentIndex < bod2Question.length - 1) {
      const newIndex = currentIndex + 1;
      setCurrentIndex(newIndex);
      localStorage.setItem("bod2_current_index", newIndex);
      window.scrollTo(0, 0);
    }
  };

  const handleBack = () => {
    if (currentIndex > 0) {
      const newIndex = currentIndex - 1;
      setCurrentIndex(newIndex);
      localStorage.setItem("bod2_current_index", newIndex);
      window.scrollTo(0, 0);
    }
  };

  const handleDisable = () => {
    let allAnswered = true;
    bod2Question.forEach((q) => {
      const hasBest = q.list_question.some((opt) => opt.answer === "BEST");
      const hasPoor = q.list_question.some((opt) => opt.answer === "POOR");
      if (!hasBest || !hasPoor) {
        allAnswered = false;
      }
    });
    return !allAnswered;
  };

  const onSend = () => {
    let questionsData = bod2Question;
    if (!questionsData || questionsData.length === 0) {
      questionsData = bod2QuestionRef.current;
    }

    if (!questionsData || questionsData.length === 0) {
      const savedAnswers = localStorage.getItem("bod2_answers");
      if (savedAnswers) {
        questionsData = JSON.parse(savedAnswers);
      }
    }

    if (!questionsData || questionsData.length === 0) {
      console.warn("No questions data, skipping submit");
      cookie.remove("elapsed_time_bod2", { path: "/" });
      cookie.remove("start_time_bod2", { path: "/" });
      return;
    }

    const submitData = {
      userId: props.profile.id,
      answers: questionsData.map((q) => {
        const bestOption = q.list_question.find((opt) => opt.answer === "BEST");
        const poorOption = q.list_question.find((opt) => opt.answer === "POOR");
        return {
          questionId: q.questionId,
          bestOptionId: bestOption ? bestOption.value : 1,
          poorOptionId: poorOption ? poorOption.value : 2,
        };
      }),
    };

    dispatch(postBod2Answer(submitData));

    localStorage.removeItem("bod2_answers");
    localStorage.removeItem("bod2_current_index");
    cookie.remove("elapsed_time_bod2", { path: "/" });
    cookie.remove("start_time_bod2", { path: "/" });
  };

  const handleTimeUp = () => {
    onSend();
  };

  if (!bod2Question || bod2Question.length === 0) {
    return (
      <div>
        <Loader />
        <Modal token={props.token} profile={props.profile} />
        {general.on_cam && <Camera profile={props.profile} />}
        <Watermark
          name={props.profile.userName}
          idNumber={detail_peserta.no_ktp}
        />
        <Navbar
          expired={expired}
          setExpired={setExpired}
          profile={props.profile}
          onTimeUp={handleTimeUp}
        />
      </div>
    );
  }

  // Desktop version with navigation
  if (!isMobile) {
    const currentQuestion = bod2Question[currentIndex];
    const isLastQuestion = currentIndex === bod2Question.length - 1;

    return (
      <div>
        <Loader />
        <Modal token={props.token} profile={props.profile} />
        {general.on_cam && <Camera profile={props.profile} />}
        <Watermark
          name={props.profile.userName}
          idNumber={detail_peserta.no_ktp}
        />
        <Navbar
          expired={expired}
          setExpired={setExpired}
          profile={props.profile}
          onTimeUp={handleTimeUp}
        />

        <div className="question-layout-desktop">
          <div className="question-content">
            <div className="question-card">
              <div className="question-number-badge">
                {currentQuestion.number}
              </div>
              <p className="question-text">{currentQuestion.questionText}</p>
            </div>

            <div className="instruction-text">
              <p>
                Tindakan yang menurut Anda <b>PALING TEPAT</b> (<i>Best</i>)
              </p>
              <p>
                Tindakan yang menurut Anda <b>PALING TIDAK TEPAT</b> (
                <i>Poor</i>)
              </p>
            </div>

            <div style={{ width: "100%" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "60px 1fr 60px",
                  gap: "10px",
                  marginBottom: 10,
                  fontWeight: "bold",
                  fontSize: 14,
                }}
              >
                <div style={{ textAlign: "center" }}>Best</div>
                <div></div>
                <div style={{ textAlign: "center" }}>Poor</div>
              </div>
              {currentQuestion.list_question.map((lq, i2) => (
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "60px 1fr 60px",
                    gap: "10px",
                    marginBottom: 10,
                    alignItems: "center",
                  }}
                  key={i2}
                >
                  <div
                    onClick={() =>
                      chooseAnswer(currentIndex, i2, lq.id, "BEST")
                    }
                    style={{
                      width: 40,
                      height: 40,
                      border:
                        lq.answer === "BEST"
                          ? "2px solid #00abbd"
                          : "2px solid #dee2e6",
                      backgroundColor:
                        lq.answer === "BEST" ? "#00abbd" : "white",
                      borderRadius: 6,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      transition: "all 0.2s",
                      margin: "0 auto",
                    }}
                  >
                    {lq.answer === "BEST" && (
                      <img
                        src={Check}
                        style={{ width: 16, filter: "brightness(0) invert(1)" }}
                        alt="check"
                      />
                    )}
                  </div>
                  <div
                    style={{
                      padding: "12px 15px",
                      backgroundColor: "#f8f9fa",
                      borderRadius: 6,
                      border: "1px solid #dee2e6",
                    }}
                  >
                    <p style={{ margin: 0, fontSize: 14, lineHeight: 1.5 }}>
                      {lq.q}
                    </p>
                  </div>
                  <div
                    onClick={() =>
                      chooseAnswer(currentIndex, i2, lq.id, "POOR")
                    }
                    style={{
                      width: 40,
                      height: 40,
                      border:
                        lq.answer === "POOR"
                          ? "2px solid #00abbd"
                          : "2px solid #dee2e6",
                      backgroundColor:
                        lq.answer === "POOR" ? "#00abbd" : "white",
                      borderRadius: 6,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      transition: "all 0.2s",
                      margin: "0 auto",
                    }}
                  >
                    {lq.answer === "POOR" && (
                      <img
                        src={Check}
                        style={{ width: 16, filter: "brightness(0) invert(1)" }}
                        alt="check"
                      />
                    )}
                  </div>
                </div>
              ))}
            </div>

            <div className="question-navigation-buttons">
              <Button
                onClick={handleBack}
                disabled={currentIndex === 0}
                style={{
                  textTransform: "none",
                  borderRadius: 20,
                  fontWeight: "bold",
                  visibility: currentIndex === 0 ? "hidden" : "visible",
                }}
                color="primary"
                variant="contained"
                size="large"
              >
                Kembali
              </Button>

              {isLastQuestion ? (
                <Button
                  disabled={handleDisable()}
                  onClick={onSend}
                  style={{
                    width: 200,
                    textTransform: "none",
                    borderRadius: 20,
                    fontWeight: "bold",
                  }}
                  color="primary"
                  variant="contained"
                  size="large"
                >
                  Kumpulkan
                </Button>
              ) : (
                <Button
                  onClick={handleNext}
                  style={{
                    textTransform: "none",
                    borderRadius: 20,
                    fontWeight: "bold",
                  }}
                  color="primary"
                  variant="contained"
                  size="large"
                >
                  Lanjut
                </Button>
              )}
            </div>
          </div>

          <QuestionNavigation
            questions={bod2Question}
            currentIndex={currentIndex}
            onNavigate={handleNavigate}
          />
        </div>
      </div>
    );
  }

  // Mobile version
  const currentQuestion = bod2Question[currentIndex];
  const isLastQuestion = currentIndex === bod2Question.length - 1;

  return (
    <div>
      <Loader />
      <Modal token={props.token} profile={props.profile} />
      {general.on_cam && <Camera profile={props.profile} />}
      <Navbar
        expired={expired}
        setExpired={setExpired}
        profile={props.profile}
        onTimeUp={handleTimeUp}
      />

      {/* Sticky Navigation Mobile */}
      <MobileStickyNav
        questions={bod2Question}
        currentIndex={currentIndex}
        onNavigate={handleNavigate}
      />

      <div className="assestment-wrapper-mobile">
        <div className="question-block-mobile">
          <div className="question-badge-mobile">
            Soal {currentQuestion.number}
          </div>

          <div className="question-card-mobile">
            <p className="question-text-mobile">
              {currentQuestion.questionText}
            </p>
          </div>

          <div className="instruction-text-mobile">
            <p>
              Tindakan yang menurut Anda <b>PALING TEPAT</b> (<i>Best</i>)
            </p>
            <p>
              Tindakan yang menurut Anda <b>PALING TIDAK TEPAT</b> (<i>Poor</i>)
            </p>
          </div>

          <div className="bod2-options-mobile">
            <div className="bod2-header-mobile">
              <div className="bod2-header-label">Best</div>
              <div></div>
              <div className="bod2-header-label">Poor</div>
            </div>

            {currentQuestion.list_question.map((lq, i2) => (
              <div key={i2} className="bod2-option-row-mobile">
                <div
                  onClick={() => chooseAnswer(currentIndex, i2, lq.id, "BEST")}
                  className={`bod2-checkbox-mobile ${lq.answer === "BEST" ? "active" : ""}`}
                >
                  {lq.answer === "BEST" && (
                    <img src={Check} style={{ width: 14 }} alt="check" />
                  )}
                </div>
                <div className="bod2-option-text-mobile">
                  <p>{lq.q}</p>
                </div>
                <div
                  onClick={() => chooseAnswer(currentIndex, i2, lq.id, "POOR")}
                  className={`bod2-checkbox-mobile ${lq.answer === "POOR" ? "active" : ""}`}
                >
                  {lq.answer === "POOR" && (
                    <img src={Check} style={{ width: 14 }} alt="check" />
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mobile-navigation-buttons">
          <Button
            onClick={handleBack}
            disabled={currentIndex === 0}
            style={{
              textTransform: "none",
              borderRadius: 20,
              fontWeight: "bold",
              minWidth: 100,
              visibility: currentIndex === 0 ? "hidden" : "visible",
            }}
            color="primary"
            variant="contained"
            size="large"
          >
            Kembali
          </Button>

          {isLastQuestion ? (
            <Button
              disabled={handleDisable()}
              onClick={onSend}
              style={{
                textTransform: "none",
                borderRadius: 20,
                fontWeight: "bold",
                minWidth: 100,
              }}
              color="primary"
              variant="contained"
              size="large"
            >
              Kumpulkan
            </Button>
          ) : (
            <Button
              onClick={handleNext}
              style={{
                textTransform: "none",
                borderRadius: 20,
                fontWeight: "bold",
                minWidth: 100,
              }}
              color="primary"
              variant="contained"
              size="large"
            >
              Lanjut
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
